module.exports = __webpack_public_path__ + "6c934a1bd1b4fa06d732f63459e2f44c.pdf";